import { apiSlice } from 'store/slices/api/api-slice';
import { CardImagesRequest } from 'types/card/card-list';
import { ImageSuccessResponse } from 'types/card/card-sphere';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        cardImageUpdate: builder.mutation<
            ImageSuccessResponse,
            CardImagesRequest
        >({
            query: (cardImagesRequest: CardImagesRequest) => ({
                url: `/card/add-card-image/` + cardImagesRequest.cardId,
                method: 'POST',
                body: cardImagesRequest.image,
                header: {},
            }),
        }),
    }),
});

export const { useCardImageUpdateMutation } = importTradeDataApiSlice;
